import Footer from "@/components/enfini/Footer";
import Button from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, Phone } from "lucide-react";
import { useEffect, useState } from "react";

export default function ContactUs() {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    youtube: "",
    message: "",
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendMail = () => {
    const subject = encodeURIComponent("Enfinity Website: Inquiries");
    const body = encodeURIComponent(
      `Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Message:
${formData.message}`
    );

    const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=requests@enfinity.com&su=${subject}&body=${body}`;
    window.open(gmailURL, "_blank");

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="bg-[linear-gradient(135deg,var(--primary),var(--tertiary))] pt-12 md:pt-8 lg:pt-6">
        <div className="p-10 md:p-16 flex flex-col lg:flex-row justify-between items-center relative overflow-hidden lg:h-screen 5xl:h-[80vh] gap-16 5xl:max-w-[100rem] 5xl:mx-auto">
          <div className="space-y-8 text-center lg:text-left lg:w-[30rem] text-white z-40">
            <p className="text-lg">WE ARE HERE TO HELP YOU</p>
            <h1 className="text-5xl md:text-6xl font-medium">
              Get in Touch
              <br />
              with <span className="capitalize">{landingPage}</span>
            </h1>
            <p className="text-lg">
              We’re here to help you protect, promote, and grow your content.
              Reach out to our team anytime.
            </p>
            <div className="space-y-6 text-left">
              <a
                href="https://mail.google.com/mail/u/0/?fs=1&to=requests@enfinity.com&tf=cm"
                target="_blank"
              >
                <div className="flex items-center gap-4 cursor-pointer">
                  <div className="bg-white p-4 text-black  rounded-lg">
                    <Mail />
                  </div>
                  <div>
                    <p>Email</p>
                    <p className="font-medium text-lg">requests@enfinity.com</p>
                  </div>
                </div>
              </a>
              <div className="flex items-center gap-4">
                <div className="bg-white p-4 text-black  rounded-lg">
                  <Phone />
                </div>
                <div>
                  <p>Phone Number</p>
                  <p className="font-medium text-lg">+63 929 151 4853</p>
                </div>
              </div>
            </div>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendMail();
            }}
            className="bg-white rounded-[20px] p-10 flex flex-col gap-8 justify-center items-center lg:w-1/2 z-40"
          >
            <div className="flex flex-col md:flex-row gap-8 md:gap-4 items-center w-full">
              <div className="space-y-3 w-full">
                <Label className="text-[#BFBFBF]">First Name</Label>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="rounded-lg py-6 bg-[#F1F0F0] focus-visible:ring-0 text-black"
                  required
                />
              </div>
              <div className="space-y-3 w-full">
                <Label className="text-[#BFBFBF]">Last Name</Label>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Enter last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="rounded-lg py-6 bg-[#F1F0F0] focus-visible:ring-0 text-black"
                  required
                />
              </div>
            </div>
            <div className="space-y-3 w-full">
              <Label className="text-[#BFBFBF]">Email</Label>
              <Input
                type="email"
                name="email"
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleInputChange}
                className="rounded-lg py-6 bg-[#F1F0F0] focus-visible:ring-0 text-black"
                required
              />
            </div>
            <div className="space-y-3 w-full">
              <Label className="text-[#BFBFBF]">Message</Label>
              <Textarea
                name="message"
                placeholder="Include your social media URLs, and explain more information on why you feel working with Enfinity would be a good fit."
                value={formData.message}
                onChange={handleInputChange}
                className="rounded-lg py-6 bg-[#F1F0F0] focus-visible:ring-0 text-black"
                required
              />
            </div>
            <Button
              type="submit"
              className="bg-primary rounded-full text-white uppercase w-full py-6"
            >
              Connect Now
            </Button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
